import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Glyphicon, Modal } from "react-bootstrap";
import toastr from "toastr";
import Swal from "sweetalert2";

import {
  AddGroupValues,
  UpdateGroupValues,
  DeleteGroupValues,
  GetGroupValues,
} from "./action";
import { FormMode } from "../../../constant";
import { NewMatchListModal } from "./new-matchlist-modal";
import { Grid } from "../../Grid";
import uuidv4 from "uuid/v4";

class MatchListModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showGroupValuesModal: false,
      formMode: FormMode.Add,

      selectedGroupValue: {
        id: "",
        name: "",
        versions: [
          {
            id: "",
            value: "",
            isNew: false,
            isDeleted: false,
          },
        ],
      },
    };
  }

  componentWillMount() {
    this.props.GetGroupValues();
  }

  toggleGroupValuesModal = () => {
    this.setState({ showGroupValuesModal: !this.state.showGroupValuesModal });
  };

  handleAddGroupValues = () => {
    this.setState({
      formMode: FormMode.Add,
      selectedGroupValue: {
        id: uuidv4(),
        name: "",
        versions: [
          {
            id: uuidv4(),
            value: "",
            isNew: true,
            isDeleted: false,
          },
        ],
      },
    });

    this.toggleGroupValuesModal();
  };

  handleEditGroupValue = (row) => (event) => {
    const versions = row.versionsList.map((v) =>
      Object.assign(
        {},
        {
          id: v.id,
          value: v.value,
          isNew: false,
          isDeleted: false,
        }
      )
    );

    this.setState({
      formMode: FormMode.Edit,
      selectedGroupValue: {
        id: row.id,
        name: row.name,
        versions: versions,
      },
    });

    this.toggleGroupValuesModal();
  };

  handleDeleteGroupValue = (row) => (event) => {
    Swal.fire({
      title: "Delete group value?",
      text: `Do you really want to delete '${row.name}'?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No",
      reverseButtons: true,
      focusConfirm: false,
      focusCancel: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          return this.props.DeleteGroupValues(
            row.id,
            this.props.configurationName
          );
        } catch (error) {
          Swal.fire(
            "An error has occurred",
            "An unexpected error has occurred. Please try again later.",
            "error"
          );
        }
      },
    }).then(async (response) => {
      if (response.value) {
        if (response.value.isSuccess) {
          Swal.fire(
            "Deleted!",
            `Group Value ${row.name} successfully deleted.`,
            "success"
          );
          await this.props.GetGroupValues();
        } else {
          Swal.fire(
            "An error has occurred",
            response.value.payload.error,
            "error"
          );
        }
      }
    });
  };

  handleSaveGroupValues = async (values, actions) => {
    const currentVersions = this.state.selectedGroupValue.versions;
    const submittedVersions = values.versions;
    const deletedVersions = [];

    currentVersions.forEach((current) => {
      const isExisting = submittedVersions.some((n) => n.id === current.id);

      if (!isExisting) {
        deletedVersions.push({
          id: current.id,
          value: current.value,
          isNew: false,
          isDeleted: true,
        });
      }
    });

    const groupValues = {
      id: values.id,
      name: values.name,
      values: [...submittedVersions, ...deletedVersions],
    };

    if (this.state.formMode === FormMode.Add) {
      const response = await this.props.AddGroupValues(
        groupValues,
        this.props.configurationName
      );

      if (response.isSuccess) {
        await this.props.GetGroupValues();
        toastr.info(
          `Group Values ${groupValues.name} successfully added.`,
          "Save"
        );

        this.toggleGroupValuesModal();
      } else {
        toastr.error(`${response.payload.error}`, "Error");
      }
    } else if (this.state.formMode === FormMode.Edit) {
      const response = await this.props.UpdateGroupValues(
        groupValues,
        this.props.configurationName
      );
      if (response.isSuccess) {
        await this.props.GetGroupValues();
        toastr.info(
          `Group Values ${groupValues.name} successfully updated.`,
          "Update"
        );

        this.toggleGroupValuesModal();
      } else {
        toastr.error(`${response.payload.error}`, "Error");
      }
    }

    actions.setSubmitting(false);
  };

  render() {
    const rowStyle = { cursor: "pointer" };
    const columns = [
      {
        dataField: "id",
        text: "Id",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            if (columnIndex < 2) {
              return this.props.onRowClick(row);
            }
          },
        },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "buttons",
        text: "",
        headerStyle: () => {
          return { width: "120px" };
        },
        formatter: (cell, row) => (
          <ButtonToolbar>
            <Button
              bsStyle="default"
              title="Edit Group Value"
              onClick={this.handleEditGroupValue(row)}
            >
              <Glyphicon glyph="edit" />
            </Button>
            <Button
              bsStyle="danger"
              title="Delete Group Value"
              onClick={this.handleDeleteGroupValue(row)}
            >
              <Glyphicon glyph="trash" />
            </Button>
          </ButtonToolbar>
        ),
      },
    ];

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Select/Manage Matchlist</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            bsStyle="primary"
            bsSize="small"
            onClick={this.handleAddGroupValues}
          >
            <Glyphicon glyph="plus" /> New Group Values
          </Button>
          <Grid
            keyField="id"
            columns={columns}
            data={this.props.list}
            rowStyle={rowStyle}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-grey" onClick={this.props.onHide}>
            Close
          </button>
        </Modal.Footer>
        <NewMatchListModal
          show={this.state.showGroupValuesModal}
          formMode={this.state.formMode}
          selectedGroupValue={this.state.selectedGroupValue}
          onFormSubmit={this.handleSaveGroupValues}
          onModalClose={this.toggleGroupValuesModal}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    list: state.configuration.matchList,
  };
};

const mapDispatchToProps = {
  AddGroupValues,
  UpdateGroupValues,
  DeleteGroupValues,
  GetGroupValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchListModal);
